<template>
  <section>
    <logged-in-header />

    <back-button />

    <cover :coverImageURL="opportunityBeingVisited.page.coverImageURL" />

    <logo :businessLogoURL="opportunityBeingVisited.page.businessLogoURL" />

    <company-name
      :businessName="opportunityBeingVisited.businessName"
      :treatmentPronoun="opportunityBeingVisited.treatmentPronoun"
      :fanpage="opportunityBeingVisited.fanpage"
      :insta="opportunityBeingVisited.insta"
      :linkedin="opportunityBeingVisited.linkedin"
      :site="opportunityBeingVisited.site"
      :opportunityId="opportunityBeingVisited._id"
    />

    <info-bottom
      v-if="opportunityBeingVisited.page.content0"
      :content="opportunityBeingVisited.page.content0"
    />

    <info1
      :contentImageURL="opportunityBeingVisited.page.contentImage1URL"
      :content="opportunityBeingVisited.page.content1"
    />

    <info2
      :contentImageURL="opportunityBeingVisited.page.contentImage2URL"
      :content="opportunityBeingVisited.page.content2"
    />

    <info-bottom
      v-if="opportunityBeingVisited.page.content3"
      :content="opportunityBeingVisited.page.content3"
    />

    <carousel
      v-if="
        opportunityBeingVisited.page.carouselImages &&
          opportunityBeingVisited.page.carouselImages.length
      "
      :carouselImages="opportunityBeingVisited.page.carouselImages"
    />

    <info-bottom
      v-if="opportunityBeingVisited.page.content4"
      :content="opportunityBeingVisited.page.content4"
    />

    <!-- <warning
      text="Ação disponível para: OEs, estudantes da graduação, pós-graduação e professores universitários"
    /> -->

    <!-- <warning text="Ação disponível para: OEs" /> -->

    <lectures-info
      :opportunityBeingVisited="opportunityBeingVisited"
      @open-card="openCard"
      @close-card="closeCard"
      :isCardOpen="isLectureCardOpen"
    />

    <visits-info
      :opportunityBeingVisited="opportunityBeingVisited"
      @open-card="openCard"
      @close-card="closeCard"
      :isCardOpen="isVisitCardOpen"
    />

    <trainings-info
      :opportunityBeingVisited="opportunityBeingVisited"
      @open-card="openCard"
      @close-card="closeCard"
      :isCardOpen="isTrainingCardOpen"
    />

    <mentorings-info
      :opportunityBeingVisited="opportunityBeingVisited"
      @open-card="openCard"
      @close-card="closeCard"
      :isCardOpen="isMentoringCardOpen"
    />

    <projects-info
      :opportunityBeingVisited="opportunityBeingVisited"
      @open-card="openCard"
      @close-card="closeCard"
      :isCardOpen="isProjectCardOpen"
    />

    <sponsorships-info
      :opportunityBeingVisited="opportunityBeingVisited"
      @open-card="openCard"
      @close-card="closeCard"
      :isCardOpen="isSponsorshipCardOpen"
    />

    <others-info
      :opportunityBeingVisited="opportunityBeingVisited"
      @open-card="openCard"
      @close-card="closeCard"
      :isCardOpen="isOtherCardOpen"
    />

    <br /><br /><br /><br />

    <empower-footer />
    <whats-app />
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import loggedInHeader from "../../components/commom/LoggedInHeader";
import backButton from "../../components/opportunity-page/BackButton";
import cover from "../../components/opportunity-page/Cover";
import logo from "../../components/opportunity-page/Logo";
import companyName from "../../components/opportunity-page/CompanyName";
import info1 from "../../components/opportunity-page/Info1";
import info2 from "../../components/opportunity-page/Info2";
import carousel from "../../components/opportunity-page/Carousel";
import infoBottom from "../../components/opportunity-page/InfoBottom";
import lecturesInfo from "../../components/opportunity-page/info-cards/InfoCardLectures";
import visitsInfo from "../../components/opportunity-page/info-cards/InfoCardVisits";
import mentoringsInfo from "../../components/opportunity-page/info-cards/InfoCardMentorings";
import trainingsInfo from "../../components/opportunity-page/info-cards/InfoCardTrainings";
import sponsorshipsInfo from "../../components/opportunity-page/info-cards/InfoCardSponsorships";
import projectsInfo from "../../components/opportunity-page/info-cards/InfoCardProjects";
import othersInfo from "../../components/opportunity-page/info-cards/InfoCardOthers";
// import warning from "../../components/opportunity-page/Warning";
import empowerFooter from "../../components/commom/EmpowerFooter";
import WhatsApp from "../../components/commom/WhatsApp";

export default {
  components: {
    loggedInHeader,
    backButton,
    cover,
    logo,
    companyName,
    info1,
    info2,
    carousel,
    infoBottom,
    lecturesInfo,
    visitsInfo,
    mentoringsInfo,
    trainingsInfo,
    sponsorshipsInfo,
    projectsInfo,
    othersInfo,
    // warning,
    empowerFooter,
    WhatsApp
  },

  data() {
    return {
      isTrainingCardOpen: false,
      isMentoringCardOpen: false,
      isVisitCardOpen: false,
      isProjectCardOpen: false,
      isLectureCardOpen: false,
      isSponsorshipCardOpen: false,
      isOtherCardOpen: false
    };
  },

  methods: {
    openCard(action) {
      if (action === "training") this.isTrainingCardOpen = true;
      if (action === "mentoring") this.isMentoringCardOpen = true;
      if (action === "visit") this.isVisitCardOpen = true;
      if (action === "project") this.isProjectCardOpen = true;
      if (action === "lecture") this.isLectureCardOpen = true;
      if (action === "sponsorship") this.isSponsorshipCardOpen = true;
      if (action === "other") this.isOtherCardOpen = true;
    },
    closeCard(action) {
      if (action === "training") this.isTrainingCardOpen = false;
      if (action === "mentoring") this.isMentoringCardOpen = false;
      if (action === "visit") this.isVisitCardOpen = false;
      if (action === "project") this.isProjectCardOpen = false;
      if (action === "lecture") this.isLectureCardOpen = false;
      if (action === "sponsorship") this.isSponsorshipCardOpen = false;
      if (action === "other") this.isOtherCardOpen = false;
    }
  },

  computed: {
    ...mapGetters(["opportunityBeingVisited"])
  }
};
</script>

<style scoped>
section {
  padding-top: 4.37rem;
}
.content-separator {
  background-color: rgb(211, 211, 211);
  height: 1px;
}
</style>
